import { render, staticRenderFns } from "./DialogChangePictureSize.vue?vue&type=template&id=7829f6ef"
import script from "./DialogChangePictureSize.vue?vue&type=script&lang=js"
export * from "./DialogChangePictureSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports